import React, { useState } from "react";

// SINGLE
import Single72 from "../../assets/icons/Mattress Guide/Icon-1.jpg";
import Single75 from "../../assets/icons/Mattress Guide/Icon-2.jpg";
import Single78 from "../../assets/icons/Mattress Guide/Icon-3.jpg";

// DOUBLE
import Double72 from "../../assets/icons/Mattress Guide/Icon-4.jpg";
import Double75 from "../../assets/icons/Mattress Guide/Icon-5.jpg";
import Double78 from "../../assets/icons/Mattress Guide/Icon-6.jpg";

// QUEEN
import Queen72 from "../../assets/icons/Mattress Guide/Icon-7.jpg";
import Queen75 from "../../assets/icons/Mattress Guide/Icon-8.jpg";
import Queen78 from "../../assets/icons/Mattress Guide/Icon-9.jpg";

// KING
import King72 from "../../assets/icons/Mattress Guide/Icon-10.jpg";
import King75 from "../../assets/icons/Mattress Guide/Icon-11.jpg";
import King78 from "../../assets/icons/Mattress Guide/Icon-12.jpg";

export default function MattressGuide() {
  // ✅ DATA STRUCTURE
  const mattressData = [
    {
      title: "Single Mattress",
      sizes: [
        { label: "72x36 Inch", cm: "(183x91.5)", image: Single72 },
        { label: "75x36 Inch", cm: "(190x91.5)", image: Single75 },
        { label: "78x36 Inch", cm: "(198x91.5)", image: Single78 },
      ],
    },
    {
      title: "Double Mattress",
      sizes: [
        { label: "72x48 Inch", cm: "(183x122)", image: Double72 },
        { label: "75x48 Inch", cm: "(190.5x122)", image: Double75 },
        { label: "78x48 Inch", cm: "(198x122)", image: Double78 },
      ],
    },
    {
      title: "Queen Mattress",
      sizes: [
        { label: "72x60 Inch", cm: "(183x152.5)", image: Queen72 },
        { label: "75x60 Inch", cm: "(190.5x152.5)", image: Queen75 },
        { label: "78x60 Inch", cm: "(198x152.5)", image: Queen78 },
      ],
    },
    {
      title: "King Mattress",
      sizes: [
        { label: "72x72 Inch", cm: "(183x183)", image: King72 },
        { label: "75x72 Inch", cm: "(190.5x183)", image: King75 },
        { label: "78x72 Inch", cm: "(198x183)", image: King78 },
      ],
    },
  ];

  // ✅ STATE (one selected size per section)
  const [selectedSizes, setSelectedSizes] = useState(
    mattressData.map((item) => item.sizes[0]),
  );

  return (
    <div>
      <div className="pt-32 pb-16">
        <div className="sm:max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto">
          {/* HEADER */}
          <div className="flex flex-col justify-center items-center text-center">
            <h1 className="text-[30px] sm:text-[38px] md:text-[46px] lg:text-[52px] font-lexend font-extralight text-[#3a683f]">
              Mattress Size Guide
            </h1>
            <p className="text-[#6d6d6d] font-lexend font-light text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] py-3">
              Getting the size of your next mattress right is key - make the
              right choice with the help of the following illustrations
            </p>
          </div>

          {/* ✅ LOOP ALL SECTIONS */}
          {mattressData.map((item, sectionIndex) => {
            const selected = selectedSizes[sectionIndex];

            return (
              <div
                key={sectionIndex}
                className="grid md:grid-cols-[40%_60%] items-center justify-center my-10 "
              >
                {/* LEFT IMAGE */}
                <div className="order-2 md:order-1">
                  <img
                    src={selected.image}
                    alt="mattress"
                  className="w-full max-w-[240px] sm:max-w-[280px] md:max-w-[320px] lg:max-w-[360px] xl:w-auto h-auto mx-auto"
                  />
                </div>

                {/* RIGHT CONTENT */}
                <div className="flex flex-col justify-center items-start order-1 md:order-2">
                  <h2 className="text-[22px] sm:text-[26px] md:text-[30px] lg:text-[36px] font-lexend text-[#3a683f] py-3">
                    {item.title}
                  </h2>

                  <h4 className="font-lexend text-[15px] sm:text-[17px] md:text-[18px] lg:text-[20px] text-[#3a683f]">
                    Available sizes
                  </h4>

                  {/* SEGMENTED BUTTONS */}
                  <div className="flex border border-[#E5D38A] rounded-lg overflow-hidden my-3">
                    {item.sizes.map((size, i) => {
                      const isActive = selected.label === size.label;

                      return (
                        <div
                          key={i}
                          onClick={() => {
                            const updated = [...selectedSizes];
                            updated[sectionIndex] = size;
                            setSelectedSizes(updated);
                          }}
                          className={`cursor-pointer px-3 py-2 xl:px-6 xl:py-3 text-[12px] xl:text-[16px] font-lexend transition-all duration-200
                        flex xl:flex-row flex-col items-center gap-1
                        ${
                          isActive
                            ? "bg-[#E5D38A] text-[#3a683f] font-medium"
                            : "bg-white text-[#6d6d6d]"
                        }
                        ${
                          i !== item.sizes.length - 1
                            ? "border-r border-[#E5D38A]"
                            : ""
                        }`}
                        >
                          <span className="font-semibold">{size.label}</span>
                          <span className="text-[14px]">{size.cm}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="bg-[#d9eada] flex justify-center items-center text-center py-5 sm:py-6 md:py-7 px-4">
        <h3 className="font-lexend font-medium text-[13px] sm:text-[15px] md:text-[18px] lg:text-[20px] text-[#6d6d6d]">We also manufacture custom-sized mattresses. When placing your order, remember to choose the exact size you need.</h3>
      </div>
    </div>
  );
}
